import ApprovedMethodologyDetails from "@/components/methodology/ApprovedMethodologyDetails";
import SEO from "@/components/shared/SEO";
import { FullPageLoader } from "@/components/shared/ui/Loader";
import useGetAdditionalInfo from "@/hooks/methodology/useGetAdditionalInfo";
import { useRouter } from "next/router";
import { useEffect } from "react";

const ApprovedMethodology = () => {
	const router = useRouter();

	const methodologyId = router.query?.id as string | undefined;

	const { data, isLoading, status, refetch } = useGetAdditionalInfo(methodologyId);

	if (status === "error") {
		router.push("/404");
	}
	useEffect(() => {
		if (data && data.latestRoundId && !router.query?.roundId) {
			router.query.roundId = data.latestRoundId.toString();
			router.push(router);
		}
	}, [data, router]);

	return (
		<>
			<SEO title="Approved Methodology Details" />
			{isLoading && <FullPageLoader />}
			{!isLoading && status !== "error" && (
				<ApprovedMethodologyDetails published={true} dataWithAdditionalInfo={data} refetch={refetch} />
			)}
		</>
	);
};

export default ApprovedMethodology;
